import { render, staticRenderFns } from "./Camp.vue?vue&type=template&id=0ec70816&"
import script from "./Camp.vue?vue&type=script&lang=js&"
export * from "./Camp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports